"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var is_object_1 = require("./is-object");
/**
 * 将对象序列化为 url 参数
 *
 * @param {*} param 需要序列化的对象
 * @param {boolean} [encode=false] 是否对 k/v 进行 urlencode
 * @returns
 */
function serializeParam(param, encode) {
    if (encode === void 0) { encode = true; }
    if (!is_object_1.default(param))
        return '';
    var queryString = [];
    for (var key in param) {
        /* istanbul ignore next */
        if (Object.prototype.hasOwnProperty.call(param, key)) {
            if (typeof param[key] !== 'undefined' && param[key] !== null) {
                var k = encode ? encodeURIComponent(key) : key;
                var v = encode ? encodeURIComponent(param[key]) : param[key];
                queryString.push(k + "=" + v);
            }
        }
    }
    return queryString.join('&');
}
exports.default = serializeParam;
//# sourceMappingURL=serialize-param.js.map